module.exports = __webpack_public_path__ + "img/ic_nav_share_white.5d3240e3.svg";